import { render, staticRenderFns } from "./phnewdetail.vue?vue&type=template&id=6c955b2a"
import script from "./phnewdetail.vue?vue&type=script&lang=js"
export * from "./phnewdetail.vue?vue&type=script&lang=js"
import style0 from "./phnewdetail.vue?vue&type=style&index=0&id=6c955b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports